import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import './admin-panel.css';

export default function AdminLogin() {
  const { isAuthenticated, login } = useAdmin();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/adminpanel" replace />;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const ok = login(username.trim(), password);
    if (ok) {
      navigate('/adminpanel', { replace: true });
    } else {
      setError('Invalid username or password.');
    }
  };

  return (
    <div className="admin-root admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <i className="fa fa-plane" />
        </div>
        <h2>Admin Panel</h2>
        <p className="subtitle">Falcon Destinations — Package Management</p>

        {error && <div className="admin-error-banner">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              autoFocus
              required
            />
          </div>
          <div className="admin-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>
          <button type="submit" className="admin-btn admin-btn-primary admin-btn-block">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
